"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _client = require("@apollo/client");
const getApolloErrorType = error => error && (0, _client.isApolloError)(error) ? error.graphQLErrors[0]?.errorType ?? error.graphQLErrors[0]?.extensions?.errorType : undefined;
var _default = exports.default = getApolloErrorType;